import { differenceInMinutes } from 'date-fns';
import debounce from 'lodash.debounce';
import { FC, useCallback, useEffect, useState } from 'react';
import { BsCreditCard, BsXCircleFill } from 'react-icons/bs';
import {
  FaCheckCircle,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';
import {
  FaChevronDown,
  FaChevronUp,
  FaCircleChevronLeft,
  FaCircleChevronRight,
  FaPix,
} from 'react-icons/fa6';
import { FiChevronRight, FiX } from 'react-icons/fi';
import { GoChevronDown, GoChevronRight } from 'react-icons/go';
import { IoLogoWhatsapp } from 'react-icons/io';
import { IoCheckbox } from 'react-icons/io5';
import { MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';
import { RiErrorWarningFill, RiInstagramFill } from 'react-icons/ri';
import Modal from 'react-modal';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Loading } from '../../../../components/Loading';
import { StyledCardInformationCar } from '../../../../components/StyledCardInformationsCar';
import { StyledInput } from '../../../../components/StyledInput';
import { usePayment } from '../../../../context/Payments';
import { useUser } from '../../../../context/UserContext';
import { listConsultsByParameters } from '../../../../hooks/useConsults';
import { ITickets, findConsultById } from '../../../../hooks/usePayments';
import theme from '../../../../styles/themes/default';
import {
  ConsultResultContainer,
  ContactContainer,
  CouponContainer,
  DebtsContainer,
  MainContainer,
  PaymentMethodsContainer,
  VehicleDetailsContainer,
} from './styles';
import { StatusModal } from '../../../../components/StatusModal';

const VehicleDetails: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useUser();

  const {
    dpvat,
    ipva,
    licenciamento,
    multas,
    handleDebtsSelection,
    ipvaSelected,
    licenciamentoSelected,
    dpvatSelected,
    multasSelected,
    handleDebtsSelectionAllByType,
    dpvatTotal,
    ipvaTotal,
    licenciamentoTotal,
    multasTotal,
    installments,
    outros,
    outrosSelected,
    outrosTotal,
    handleSetCupom,
    cupomStatus,
    vehicle,
    entryMessage,
    exitMessage,
    installmentsLoading,
    setReady,
    ready,
    consultCode,
    clear,
    handleSetVehicle,
    getDebts,
    pix,
    pixTax,
    setRecovery,
    cupom: hookCupom,
    availableCoupon,
    owner,
    renavam,
    handleSelectInstallment,
    handleSelectPix,
  } = usePayment();

  const userVehicleInfoStorage = localStorage.getItem('userVehicleInfo');
  const [fullInfo, setFullInfo] = useState<any | undefined>();
  const [code, setCode] = useState<number | null>(null);
  const [sub, setSub] = useState<string | null>(null);
  const [car, setCar] = useState<any | undefined>({
    placa: '',
    marca: '',
    ano: '',
  });
  const [tickets, setTickets] = useState<any>([]);

  // modal
  const [entryMessageModal, setEntryMessageModal] = useState(false);
  const [exitMessageModal, setExitMessageModal] = useState(false);
  const [exitMessageComponent, setExitMessage] = useState('');
  const [showModalConfirmedPix, setShowModalConfirmedPix] = useState(false);

  const [cupom, setCupom] = useState<string | undefined>(undefined);
  const [consultDate, setConsultDate] = useState<string>('');

  const [totalValues, setTotalValues] = useState<any>({
    multas: 0,
    dpvat: 0,
    ipva: 0,
    licenciamento: 0,
    outros: 0,
  });
  const [allChecked, setAllChecked] = useState<any>([]);

  // payments
  const [zignetFee, seZignetFee] = useState<number>(0);

  // bool
  const [loading, setLoading] = useState<boolean>(false);

  // toggle
  const [showCoupon, setShowCoupon] = useState<boolean>(true);
  const [showTickets, setShowTickets] = useState<any>({
    multas: true,
    dpvat: true,
    ipva: true,
    licenciamento: true,
    outros: true,
  });
  const [openCreditContainer, setOpenCreditContainer] = useState<boolean>(true);
  const [openPixContainer, setOpenPixContainer] = useState<boolean>(
    pix?.checked ?? true,
  );

  useEffect(() => {
    const formatDate = new Intl.DateTimeFormat('pt-Br', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date());

    setConsultDate(formatDate);

    setReady(false);

    const hasDebtSelected =
      [
        ...ipvaSelected,
        ...licenciamentoSelected,
        ...dpvatSelected,
        ...multasSelected,
        ...outrosSelected,
      ].length > 0;

    if (!hasDebtSelected) {
      handleDebtsSelectionAllByType('ipva', true);
      handleDebtsSelectionAllByType('dpvat', true);
      handleDebtsSelectionAllByType('multas', true);
      handleDebtsSelectionAllByType('outros', true);
      handleDebtsSelectionAllByType('licenciamento', true);
    }

    setReady(true);
  }, []);

  useEffect(() => {
    try {
      setLoading(true);
      setTickets([
        { name: 'ipva', data: ipva },
        { name: 'licenciamento', data: licenciamento },
        { name: 'multas', data: multas },
        { name: 'dpvat', data: dpvat },
        { name: 'outros', data: outros },
      ]);

      if (ipva.length > 0) {
        handleDebtsSelectionAllByType('ipva', true);
      }
      if (dpvat.length > 0) {
        handleDebtsSelectionAllByType('dpvat', true);
      }
      if (multas.length > 0) {
        handleDebtsSelectionAllByType('multas', true);
      }
      if (outros.length > 0) {
        handleDebtsSelectionAllByType('outros', true);
      }
      if (licenciamento.length > 0) {
        handleDebtsSelectionAllByType('licenciamento', true);
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }, [multas, ipva, dpvat, outros, licenciamento, ready]);

  useEffect(() => {
    console.log('');
    setAllChecked([
      { name: 'ipva', data: ipvaSelected },
      { name: 'licenciamento', data: licenciamentoSelected },
      { name: 'multas', data: multasSelected },
      { name: 'dpvat', data: dpvatSelected },
      { name: 'outros', data: outrosSelected },
    ]);
  }, [
    multasSelected,
    ipvaSelected,
    dpvatSelected,
    outrosSelected,
    licenciamentoSelected,
  ]);

  useEffect(() => {
    (async () => {
      if (userVehicleInfoStorage) {
        setLoading(true);
        const vehicleInfoLocalStorageParsed = JSON.parse(
          userVehicleInfoStorage,
        );

        if (vehicleInfoLocalStorageParsed?.vehicle) {
          setCar(vehicleInfoLocalStorageParsed?.vehicle);
          handleSetVehicle(vehicleInfoLocalStorageParsed?.vehicle);
        }

        if (vehicleInfoLocalStorageParsed?.consult?.correlation) {
          const consultsList = await listConsultsByParameters({
            correlation: vehicleInfoLocalStorageParsed?.consult?.correlation,
          });

          if (!fullInfo) {
            setFullInfo({
              ...vehicleInfoLocalStorageParsed,
              consults: consultsList.map((each) => each.dataConsulta),
            });
          }
          
        } else {
          setFullInfo({
            ...vehicleInfoLocalStorageParsed,
          });
        }
        setLoading(false);
      }
    })();
  }, [userVehicleInfoStorage]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const codeParam = params.get('code');
    const userSubParam = params.get('sub');

    setCode(Number(codeParam ?? 0));
    setSub(userSubParam);
  }, [location]);

  useEffect(() => {
    if (code) {
      // localStorage.removeItem('@Zignet:consulta');
      // handleRecoveryConsult(
      //   code,
      //   sub as string
      // );
    } else if (!consultCode) {
      setRecovery(true);
    }
  }, [sub, code]);

  useEffect(() => {
    setTotalValues({
      multas: multasTotal,
      dpvat: dpvatTotal,
      ipva: ipvaTotal,
      licenciamento: licenciamentoTotal,
      outros: outrosTotal,
    });
  }, [multasTotal, dpvatTotal, ipvaTotal, licenciamentoTotal, outrosTotal]);

  useEffect(() => {
    setLoading(installmentsLoading);
  }, [installmentsLoading]);

  // payments
  useEffect(() => {
    const installment = installments.find((i) => i.checked === true);
    if (installment) {
      const zignetFee =
        Number(installment?.totalPrice) -
          (ipvaTotal + licenciamentoTotal + dpvatTotal + multasTotal) || 0;
      seZignetFee(zignetFee);
    } else {
      const zignetFee =
        Number(pix?.totalPrice) -
          (ipvaTotal + licenciamentoTotal + dpvatTotal + multasTotal) || 0;
      seZignetFee(zignetFee);
    }
  }, [
    installments,
    ipvaTotal,
    licenciamentoTotal,
    dpvatTotal,
    multasTotal,
    pix,
    zignetFee,
  ]);

  useEffect(() => {
    setCupom(hookCupom);
  }, [hookCupom]);

  useEffect(() => {
    setEntryMessageModal(!!entryMessage);
  }, [entryMessage])

  useEffect(() => {
    setExitMessage(exitMessage)
  }, [exitMessage])

  useEffect(() => {
    if (pix?.checked && !openPixContainer) {
      setOpenPixContainer(true);
    }
  }, [pix]);

  function checkExpirationTicket(expiration: string) {
    const currentDate = new Date();
    const givenDate = new Date(expiration);

    // Convertendo para o mesmo dia da data atual às 00:00:00
    currentDate.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    return currentDate.getTime() > givenDate.getTime();
  }

  function handleMoneyValues(value: string | number) {
    return `R$ ${(value || 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  function handleCheckedItem(checkTicket: ITickets, name: string) {
    let selected = false;

    if (name === 'ipva') {
      selected = ipva.find((i) => i?.codigo === checkTicket?.codigo)?.disable
        ? false
        : ipvaSelected.find((i) => i?.codigo === checkTicket?.codigo)
        ? true
        : false;
    }

    if (name === 'multas') {
      selected = multas.find((i) => i?.codigo === checkTicket?.codigo)?.disable
        ? false
        : multasSelected.find((i) => i?.codigo === checkTicket?.codigo)
        ? true
        : false;
    }

    if (name === 'dpvat') {
      selected = dpvat.find((i) => i?.codigo === checkTicket?.codigo)?.disable
        ? false
        : dpvatSelected.find((i) => i?.codigo === checkTicket?.codigo)
        ? true
        : false;
    }

    if (name === 'outros') {
      selected = outros.find((i) => i?.codigo === checkTicket?.codigo)?.disable
        ? false
        : outrosSelected.find((i) => i?.codigo === checkTicket?.codigo)
        ? true
        : false;
    }

    if (name === 'licenciamento') {
      selected = licenciamento.find((i) => i?.codigo === checkTicket?.codigo)
        ?.disable
        ? false
        : licenciamentoSelected.find((i) => i?.codigo === checkTicket?.codigo)
        ? true
        : false;
    }

    return selected;
  }

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const updateShowTickets = (key: string, value: boolean) => {
    setShowTickets((prevState: any) => ({
      ...prevState,
      [key]: !value,
    }));
  };

  const debouncedSave = useCallback(
    debounce((nextValue: any) => handleSetCupom(nextValue), 1000),
    [],
  );

  const handleCupomInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const regex = /[⁰¹²³⁴⁵⁶⁷⁸⁹ºª]/g;
      const value = e.currentTarget.value.replace(regex, '');

      setCupom(value);

      if (value.length === 0 || value.length > 4) {
        debouncedSave(value);
      }
    },
    [debouncedSave],
  );

  const handleClickExitMessageModal = useCallback(() => {
    setExitMessageModal(false);
    if (!isLoggedIn) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Necessário fazer login ou cadastro',
        confirmButtonColor: theme.colors.orange.primary,
      });
    } else {
      setLoading(true);
      if (pix.checked) {
        navigate('/debts/pix');
      } else {
        navigate('/debts/credit-card');
      }
      setLoading(false);
    }
  }, [isLoggedIn, pix.checked, navigate]);

  const handleClickEntryMessageModal = useCallback(() => {
    setEntryMessageModal(false);
    if (availableCoupon) {
      setCupom(availableCoupon);
      handleSetCupom(availableCoupon);
    }
  }, [availableCoupon, handleSetCupom]);

  const handlePayNowButton = useCallback(async () => {
    const total =
      dpvatTotal + ipvaTotal + licenciamentoTotal + multasTotal + outrosTotal;

    if (total === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Nenhum débito selecionado',
        confirmButtonColor: theme.colors.orange.primary,
      });
      return;
    }

    if (!cupomStatus) {
      setCupom('');
      handleSetCupom('');
    }

    setLoading(true);

    const storageConsult = await findConsultById(consultCode);
    console.log('storageConsult', storageConsult);

    if (storageConsult.payloadCaptura) {
      setLoading(false);
      window.localStorage.setItem(
        'zignet:ConsultInProgress',
        JSON.stringify(storageConsult),
      );
      window.localStorage.setItem(
        'zignet:PayloadCaptura',
        JSON.stringify(storageConsult.payloadCaptura),
      );
      window.localStorage.setItem(
        'zignet:PayloadComprovante',
        JSON.stringify(storageConsult.payloadComprovante),
      );
      window.localStorage.setItem(
        'zignet:PayloadConsulta',
        JSON.stringify(storageConsult.payloadConsulta),
      );
      Swal.fire({
        icon: 'warning',
        html: `Já existe um pagamento em andamento para este veículo;`,
        confirmButtonColor: theme.colors.orange.primary,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/proof');
        }
      });
      return;
    }

    const checkConsultDuration =
      differenceInMinutes(new Date(), new Date(storageConsult?.created_at)) -
      180;
    console.log(
      '🚀 ~ handlePayNowButton ~ checkConsultDuration:',
      checkConsultDuration,
    );

    setLoading(false);

    // if (checkConsultDuration >= 30) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Aviso!',
    //     html: 'Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento',
    //     confirmButtonColor: theme.colors.orange.primary,
    //   });
    //   return;
    // }

    if (exitMessageComponent !== '') {
      setExitMessageModal(true);
      return;
    }


    if (!isLoggedIn) {
      Swal.fire({
        icon: 'warning',
        title: 'Aviso!',
        html: 'Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento',
        confirmButtonColor: theme.colors.orange.primary,
      });
    } else {
      console.log('Entrou aqui2');
      setLoading(true);
      if (pix.checked) {
        navigate('/debts/pix');
      } else {
        navigate('/debts/credit-card');
      }
    }
  }, [
    dpvatTotal,
    ipvaTotal,
    licenciamentoTotal,
    multasTotal,
    outrosTotal,
    cupomStatus,
    consultCode,
    isLoggedIn,
    handleSetCupom,
    navigate,
    pix.checked,
    exitMessageComponent
  ]);

  return (
    <MainContainer>
      {loading && <Loading position="fixed" />}
      <Modal
        isOpen={entryMessageModal}
        onRequestClose={handleClickEntryMessageModal}
        className={'entryMessageModalContainer'}
        style={{
          overlay: { zIndex: 1001 },
          content: {},
        }}
      >
        <div
          className={'entryMessageModal'}
          dangerouslySetInnerHTML={{
            __html: entryMessage,
          }}
        ></div>
        <div className="entryMessageModalButton">
          <button type="button" onClick={handleClickEntryMessageModal}>
            {availableCoupon ? 'Aplicar cupom' : 'Continuar'}
            <FiChevronRight />
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={entryMessageModal}
        onRequestClose={handleClickEntryMessageModal}
        className={'entryMessageModalContainer'}
        style={{
          overlay: { zIndex: 1001 },
          content: {},
        }}
      >
        <div
          className={'entryMessageModal'}
          dangerouslySetInnerHTML={{
            __html: entryMessage,
          }}
        ></div>
        <div className={'entryMessageModalButton'}>
          <button type="button" onClick={handleClickEntryMessageModal}>
            {availableCoupon ? 'Aplicar cupom' : 'Continuar'}
            <FiChevronRight />
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={exitMessageModal}
        onRequestClose={() => setExitMessageModal(false)}
        className={'exitMessageModalContainer'}
        style={{
          overlay: { zIndex: 1001 },
          content: {},
        }}
      >
        <div
          className={'exitMessageModal'}
          dangerouslySetInnerHTML={{
            __html: exitMessage,
          }}
        ></div>
        <div className={'exitMessageModalButton'}>
          <button type="button" onClick={handleClickExitMessageModal}>
            {'Continuar'}
            <FiChevronRight />
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={showModalConfirmedPix}
        onRequestClose={() => setShowModalConfirmedPix(false)}
        className={'modalConfirmedPix'}
        style={{
          overlay: { zIndex: 1001 },
          content: {},
        }}
      >
        <div className={'iconWarning'}>
          <RiErrorWarningFill size="44" />
        </div>
        <div
          className={'txtPoliticaPrivacidade'}
          id="warning-message"
          style={{
            textAlign: 'center',
          }}
        >
          Você está finalizando o pagamento de débitos do seguinte veículo:
          {owner !== '' && (
            <p
              style={{
                textAlign: 'center',
              }}
            >
              Proprietário{' '}
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                {owner}
              </span>
            </p>
          )}
          <p
            style={{
              textAlign: 'center',
            }}
          >
            Placa{' '}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {vehicle.placa}
            </span>
          </p>
          <p
            style={{
              textAlign: 'center',
            }}
          >
            Detran{' '}
            <span
              style={{
                fontWeight: 600,
              }}
            >
              {vehicle.uf}
            </span>
          </p>
          {renavam !== '' && (
            <p
              style={{
                textAlign: 'center',
              }}
            >
              Renavam{' '}
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                {`*****${renavam.slice(-4)}`}
              </span>
            </p>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            width: '100%',
          }}
        >
          <div className={'modalButton'}>
            <button
              onClick={() => {
                setShowModalConfirmedPix(false);
              }}
            >
              Fechar
              <FiX />
            </button>
          </div>
          <div className={'modalButton'}>
            <button
              onClick={() => {
                setShowModalConfirmedPix(false);
                handlePayNowButton();
              }}
            >
              Pagar
              <FiChevronRight />
            </button>
          </div>
        </div>
      </Modal>
      <VehicleDetailsContainer>
        <div className="details-container">
          <ConsultResultContainer>
            <div className="header">
              <span className="title-txt">Resultados da consulta</span>
              <span className="info">
                Consulta realizada no DETRAN {consultDate}
              </span>
            </div>
            <span className="title">Informações do veículo</span>
            <div className="car-details">
              {/* <div className='infos'>
                <div className='header'>
                  <div className='placa'>
                    <FaCarSide className='car-icon' />
                    <span>Placa: {car.placa}</span>
                  </div>
                  <div className='place'>
                    <FaMagnifyingGlass />
                    <span>{`DETRAN ${car.uf}`}</span>
                  </div>
                </div>
                <span><strong>Ano: </strong>{car.ano}</span>
                <span><strong>Marca: </strong>{car.marca}</span>
              </div> */}
              <StyledCardInformationCar
                plate={car.placa}
                uf={car.uf}
                year={car.ano}
                brand={car.marca}
              ></StyledCardInformationCar>
              <div className="warn-message">
                <p>
                  Para efetuar o licenciamento de seu veículo,{' '}
                  <strong>todos os débitos vencidos</strong> precisam estar
                  pagos. Em caso de dúvidas, nos chame no Whatsapp{' '}
                  {'(11)94549-1306.'}
                </p>
              </div>
            </div>
            <div className="tickets">
              <DebtsContainer>
                {tickets.map((debts: any, i: number) => {
                  if (debts?.data?.length === 0) return <></>;

                  const checked =
                    allChecked?.filter((x: any) => x.name === debts.name)[0]
                      .data?.length ?? 0;

                  return (
                    <div
                      className={`debts ${
                        i + 1 ===
                        tickets.filter((x: any) => x.data.length !== 0)?.length
                          ? 'last'
                          : ''
                      }`}
                    >
                      <div className="tickets-togg">
                        <div className="quantity">
                          {checked ? (
                            <IoCheckbox
                              className={`checkbox-item`}
                              onClick={() =>
                                handleDebtsSelectionAllByType(debts.name)
                              }
                            />
                          ) : (
                            <MdOutlineCheckBoxOutlineBlank
                              onClick={() =>
                                handleDebtsSelectionAllByType(debts.name)
                              }
                              className={`checkbox-item`}
                            />
                          )}
                          <span
                            onClick={() =>
                              updateShowTickets(
                                debts.name,
                                showTickets[debts.name],
                              )
                            }
                          >{`${debts.name.toUpperCase()} (${checked} de ${
                            debts.data.length
                          } selecionados)`}</span>
                          {!showTickets[debts.name] ? (
                            <FaChevronDown
                              onClick={() =>
                                updateShowTickets(
                                  debts.name,
                                  showTickets[debts.name],
                                )
                              }
                            />
                          ) : (
                            <FaChevronUp
                              onClick={() =>
                                updateShowTickets(
                                  debts.name,
                                  showTickets[debts.name],
                                )
                              }
                            />
                          )}
                        </div>
                        <span className="total">
                          {handleMoneyValues(totalValues[debts.name] ?? 0)}
                        </span>
                      </div>
                      {showTickets[debts.name] && (
                        <div
                          className={`tickets-container  ${
                            i + 1 === tickets.length ? 'last' : ''
                          }`}
                        >
                          {debts?.data?.map((ticket: any, b: number) => {
                            const expired = checkExpirationTicket(
                              ticket.vencimento,
                            );

                            return (
                              <div
                                key={`ticket-${b}`}
                                className={`ticket ${
                                  b + 1 === debts.data.length ? 'last' : ''
                                }`}
                                onClick={() =>
                                  handleDebtsSelection(debts.name, ticket)
                                }
                              >
                                {handleCheckedItem(ticket, debts.name) ? (
                                  <IoCheckbox className={`checkbox-item`} />
                                ) : (
                                  <MdOutlineCheckBoxOutlineBlank
                                    className={`checkbox-item`}
                                  />
                                )}
                                <div className="ticket-description">
                                  <p>{`Vencimento: ${formatDate(
                                    ticket.vencimento,
                                  )} - ${ticket.descricao} ${
                                    ticket.descricaoAdicional
                                  }`}</p>
                                </div>
                                <div className="ticket-value">
                                  <span className="value">
                                    {handleMoneyValues(ticket.valor)}
                                  </span>
                                  <span
                                    className={`${
                                      expired ? 'expired' : 'normal'
                                    }`}
                                  >
                                    {expired ? 'Vencido' : 'A Vencer'}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </DebtsContainer>
            </div>
          </ConsultResultContainer>

          <div className="contact-and-ticket">
            <ContactContainer>
              <h3>DÚVIDAS? FALE CONOSCO!</h3>

              <div className="content">
                <div className="hour-address">
                  <div className="item">
                    <strong>Horário de Funcionamento</strong>
                    <span>Seg. a Sex. - 08hs às 19hs</span>
                  </div>
                  <div className="item">
                    <strong>Capital de SP e Regiões</strong>
                    <span>11 5171-8484</span>
                  </div>
                  <div className="item">
                    <strong>Demais Localidades</strong>
                    <span>0800 5800 094</span>
                  </div>
                </div>
                <div className="contacts">
                  <div className="item">
                    <strong>WhatsApp</strong>
                    <span>11 94549-1306</span>
                  </div>
                  <div className="item">
                    <strong>E-mail</strong>
                    <span>atendimento@zignet.com.br</span>
                  </div>
                  <div className="item icons">
                    <a
                      href="https://web.facebook.com/zignetbrasil"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebook />
                    </a>
                    <a
                      href="https://www.instagram.com/Zignet_oficial/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <RiInstagramFill />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/zignet/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaLinkedin />
                    </a>
                    <a
                      href="https://api.whatsapp.com/send?phone=5511945491306&text=Ol%C3%A1,%20Zignet"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <IoLogoWhatsapp />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UC07YZyHWRKS2xIbFptaT8Bg "
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaYoutube />
                    </a>
                  </div>
                </div>
              </div>
            </ContactContainer>
            <CouponContainer valid={cupomStatus} open={showCoupon}>
              <div className="coupon-container">
                <div className="header-togg">
                  <div
                    className="main-togg"
                    onClick={() => setShowCoupon(!showCoupon)}
                  >
                    <span> Inserir Cupom de Desconto </span>
                    {!showCoupon ? <FaChevronDown /> : <FaChevronUp />}
                  </div>
                  {availableCoupon && (
                    <div
                      className="available-status"
                      onClick={() => setEntryMessageModal(!entryMessageModal)}
                    >
                      <FaCheckCircle />
                      <span>Cupom disponível</span>
                    </div>
                  )}
                </div>
                <div
                  className={`content ${
                    cupomStatus === undefined ? 'neutral' : ''
                  }`}
                >
                  {showCoupon && (
                    <div className="ticket-input">
                      <StyledInput
                        placeholder="Insira seu cupom de desconto"
                        value={cupom}
                        onChange={handleCupomInput}
                        icon={
                          cupom !== undefined && cupom.length > 0 ? (
                            cupomStatus ? (
                              <FaCheckCircle />
                            ) : (
                              <BsXCircleFill />
                            )
                          ) : undefined
                        }
                      />
                    </div>
                  )}
                  <div className="descount-values">
                    <div className="descount">
                      <span>Desconto aplicado</span>
                      <span>
                        {handleMoneyValues(
                          -installments.find((i) => i.checked)?.discount! ||
                            -pix?.discount! ||
                            0,
                        )}
                      </span>
                    </div>
                    <div className="values">
                      <strong>Total Selecionado</strong>
                      <strong>
                        {handleMoneyValues(
                          ipvaTotal +
                            licenciamentoTotal +
                            dpvatTotal +
                            multasTotal +
                            zignetFee || 0,
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="actions">
                <div className="new-consult" onClick={() => navigate(-1)}>
                  <FaCircleChevronLeft />
                  <span>Nova Consulta</span>
                </div>
                <div
                  className="submit-btn"
                  onClick={() => {
                    if (pix.checked) {
                      setShowModalConfirmedPix(true);
                    } else {
                      handlePayNowButton();
                    }
                  }}
                >
                  <span>Pagar Agora</span>
                  <FaCircleChevronRight />
                </div>
              </div>
            </CouponContainer>
          </div>
        </div>
      </VehicleDetailsContainer>

      <PaymentMethodsContainer>
        <span className="title">Métodos de pagamento</span>
        <div className="payment-methods">
          {pix?.month && (
            <div className="pix-container">
              <div
                className="payment-option"
                onClick={() => setOpenPixContainer(!openPixContainer)}
              >
                <FaPix />
                <span>PIX</span>
                {openPixContainer ? <GoChevronDown /> : <GoChevronRight />}
              </div>
              {openPixContainer && (
                <div className="credit-options">
                  <div
                    onClick={() => handleSelectPix()}
                    className={`credit-option ${pix.checked ? 'selected' : ''}`}
                  >
                    {pix.checked ? (
                      <IoCheckbox className={`checkbox-item`} />
                    ) : (
                      <MdOutlineCheckBoxOutlineBlank
                        className={`checkbox-item`}
                      />
                    )}
                    <div className="option-infos">
                      <div className="values">
                        <span>
                          {`${pix.month}x de`}{' '}
                          <strong>{`${handleMoneyValues(
                            Number(pix.installmentPrice),
                          )}`}</strong>
                        </span>

                        <p>
                          {handleMoneyValues(Number(pix.totalPrice))}{' '}
                          <span>{`(Taxa PIX: ${handleMoneyValues(
                            installmentsLoading ? 0 : pixTax,
                          )})`}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {installments.length > 0 && (
            <div className="credit-container">
              <div
                className="payment-option"
                onClick={() => setOpenCreditContainer(!openCreditContainer)}
              >
                <BsCreditCard />
                <span>{`Cartão de Crédito (em até ${installments?.length}x)`}</span>
                {openCreditContainer ? <GoChevronDown /> : <GoChevronRight />}
              </div>
              {openCreditContainer && (
                <div className="credit-options">
                  {installments.map((installment, i) => {
                    const {
                      month,
                      installmentPrice,
                      totalPrice,
                      checked,
                      cet,
                    } = installment;

                    return (
                      <div
                        key={`credit-${i}`}
                        onClick={() => handleSelectInstallment(installment)}
                        className={`credit-option ${checked ? 'selected' : ''}`}
                      >
                        {checked ? (
                          <IoCheckbox className={`checkbox-item`} />
                        ) : (
                          <MdOutlineCheckBoxOutlineBlank
                            className={`checkbox-item`}
                          />
                        )}
                        <div className="option-infos">
                          <div className="values">
                            <span>
                              {`${month}x de`}{' '}
                              <strong>{`${handleMoneyValues(
                                Number(installmentPrice),
                              )}`}</strong>
                            </span>

                            <p>
                              {handleMoneyValues(Number(totalPrice))}{' '}
                              {installment?.month !==
                                installments[0]?.month && (
                                <span>CET {cet}% ao mês</span>
                              )}
                            </p>
                          </div>
                          {installment?.month === installments[0]?.month && (
                            <div className="best-option">
                              <span className="best-title">RECOMENDADO</span>
                              <span className="best-cet">{`(CET ${cet}% ao mês)`}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </PaymentMethodsContainer>
    </MainContainer>
  );
};

export default VehicleDetails;
